import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Observable } from 'rxjs';

interface VerifyNumber {
  countryCode: string;
  phoneNumber: string;
  email: string;
  captchaToken?: string | null;
}

interface VerifyOTP {
  countryCode: string;
  phoneNumber: string;
  resetCode: string;
}

interface PasswordPayload {
  phoneNumber: string;
  resetCode: string;
  newPassword: string;
}

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {
  constructor(
    public apiService: ApiService
  ) { }

  sendResetCode(payload: VerifyNumber): Observable<any> {
    return this.apiService.post('v2/user/forgot-password', payload) as Observable<any>;
  }

  verifyOTP(payload: VerifyOTP): Observable<any> {
    return this.apiService.post('user/forgot-password/confirm', payload) as Observable<any>;
  }

  resetPassword(payload: PasswordPayload): Observable<any> {
    return this.apiService.post('user/forgot-password/reset', payload) as Observable<any>;
  }
}
